module.exports = "/fonts/efiling-picturemark-l-5b5d6863e29d45434d1ffd8bd324aff6.svg";